import * as React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material';
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useState, useEffect } from "react";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
export default function Iso_spec() {
  
 
    const [sampleStatus, setSampleSattus] = React.useState([]);

    const autoTextSampleStatus = (event) => {
        //
        const SampleStatusobj = [
            { title: 'Arrived at the Lab' },
            { title: 'Analysed' },
            { title: 'Reported' },
            { title: 'Other' },
        ]
        setSampleSattus(SampleStatusobj);
        // let searchStr = event.target.value;
        // setValue(searchStr);
        // //console.log(searchStr,"SEARCH");
        // const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Customer/${searchStr}`;
        // getRequest(url)
        //     .then((res) => {
        //         // //console.log(res);
        //         if (res.status == 200) {
        //             let totalArray = [];
        //             res.data.map((item) => {
        //                 if (item.customerName || item.customerkeys) {
        //                     totalArray.push(item);
        //                 }
        //             });
        //             setCustomerDetailsBySearch(totalArray);
        //         } else {
        //             ToastError(res.data.message);
        //         }
            // })
            // .catch((error) => {
            //     //console.log(error);
            //     // ToastError(error.response.data.message);
            // });
    }
    return (
        <Stack spacing={3}>


            <Autocomplete
                multiple
                id="size-small-standard-multi"
                size="small"
                // fullWidth
                options={sampleStatus}
                getOptionLabel={(option) => option.title}
                //defaultValue={[top100Films[13]]}
               
               
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label="ISO Specifications"
                        //placeholder="Favorites"
                        onChange={autoTextSampleStatus}

                    />
                )}
            />


        </Stack>
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
